import {
  CreateInvitation,
  reqCreateInvitation,
  GetUserInformation,
  reqGetUserInformation,
  DeleteInvitation,
  reqDeleteInvitation,
  GetInvitations,
  reqGetInvitations,
  GetInvitedContacts,
  reqGetInvitedContacts,
} from '@weblite/ts-action/invitation'
// @ts-ignore
import hostConf from '$config/frontend'
import { request } from '$setup/ws'
import { t } from '$i18n'
import { invitationStorage } from '$logic/invite/storage'
import { normalizePhone } from '$func/phone'
import { isPhoneOrTablet } from '$func/environmentInfo'
import { shareText } from '$helper/functions/share-api'

export async function inviteViaPhoneNumber(
  phoneNumber: string[],
  canInvite: boolean,
) {
  const normalizedPhoneNumber = phoneNumber.map(normalizePhone)
  // console.log(`sms:${phoneNumber.filter(Boolean).join(',')}?body=hello%20there`)

  const res = await request<CreateInvitation>(
    reqCreateInvitation({
      phoneNumber: normalizedPhoneNumber,
      canInvite,
    }),
  )
  if (res.error) {
    // TODO: Snackbar
  }
  const { shareable, onShare } = shareText(t('invite.sms'))
  if (shareable) onShare()

  // if (isPhoneOrTablet)
  //   window.open(
  //     `sms:${phoneNumber.filter(Boolean).join(',')}?body=${t('invite.sms')}`,
  //   )
}

export async function getInvitations() {
  const res = await request<GetInvitations>(reqGetInvitations({}))
  if (res.error) throw new Error(res.error.message.toString())
  return res.payload
}
export async function deleteInvitation(phoneNumber: string) {
  const res = await request<DeleteInvitation>(
    reqDeleteInvitation({ phoneNumber }),
  )
  // if (res.error) {
  // }
}

export async function syncInvitationInfo() {
  if (!hostConf.HAS_INVITATION) return
  const invitationDB = await invitationStorage.get()
  if (invitationDB) return
  const res = await request<GetUserInformation>(reqGetUserInformation({}))
  if (res.error) return
  await invitationStorage.set(res.payload)
}

export function getMyInviter() {
  const invitationDB = invitationStorage.get()
  if (!invitationDB) return ''
  return invitationDB.inviter
}
export function getCanInvite() {
  const invitationDB = invitationStorage.get()
  if (!invitationDB) return false
  return invitationDB.canInvite
}

export async function getInvitedContacts() {
  const res = await request<GetInvitedContacts>(reqGetInvitedContacts({}))
  if (res.error) return [] as string[]
  return res.payload.phoneNumbers
}
